// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Alert_hidden__3g8u1","visible":"Alert_visible__3cJyT","title":"Alert_title__3iGh6","button":"Alert_button__3roUw"};